document.addEventListener('DOMContentLoaded', function () {
    new Vue({
        el: '.header-inner',
        data: {
            selectedDropdownId: null,
            mobileNavOpen: false,
            accessibilityMode: false, // Initialisering af data
        },
        methods: {
            toggleDropdown(linkId) {
                if (!linkId) {
                    this.closeDropdown();
                    return;
                }

                const dropdownId = linkId + "-dropdown";
                const dropdown = document.getElementById(dropdownId);
                const button = document.getElementById(linkId);

                if (!dropdown || !button) {
                    console.error(`Elementer ikke fundet: dropdownId=${dropdownId}, linkId=${linkId}`);
                    return;
                }

                if (dropdownId !== this.selectedDropdownId) {
                    // Luk tidligere dropdown
                    this.closeDropdown();

                    // Åbn ny dropdown
                    this.selectedDropdownId = dropdownId;
                    dropdown.setAttribute("aria-hidden", "false");
                    button.setAttribute("aria-expanded", "true");

                    // Flyt fokus til det første element i dropdownen
                    this.$nextTick(() => {
                        const firstFocusable = dropdown.querySelector('ul li a');
                        setTimeout(function () {
                            dropdown.focus();
                        }, 500)
                        //if (firstFocusable) {
                        //    console.log("Flyt fokus", firstFocusable)
                        //    setTimeout(function () {
                        //        firstFocusable.focus();
                        //    }, 1000);
                        //}
                    });
                } else {
                    // Luk dropdown
                    this.closeDropdown();
                    document.getElementById(linkId).focus();
                }
            },
            closeDropdown() {
                if (this.selectedDropdownId) {
                    const dropdown = document.getElementById(this.selectedDropdownId);
                    const button = document.querySelector(`[aria-controls="${this.selectedDropdownId}"]`);

                    if (dropdown) {
                        dropdown.setAttribute("aria-hidden", "true");
                        document.getElementById(this.selectedDropdownId.replace("-dropdown", "")).focus();
                    }
                    if (button) {
                        button.setAttribute("aria-expanded", "false");
                        button.focus(); // Returner fokus til knappen
                    }
                }
                this.selectedDropdownId = null;
            },
            toggleMobileNav() {
                this.mobileNavOpen = !this.mobileNavOpen;
                this.closeDropdown(); // Luk dropdowns, når mobilenavigation åbnes/lukkes
            },
            toggleAccessibilityMode() {
                this.accessibilityMode = !this.accessibilityMode;

                // Sæt en cookie til tilgængelighedstilstand
                document.cookie = "accessibilityMode=" + (this.accessibilityMode ? "true" : "false") + "; path=/;";
                const htmlElement = document.querySelector("html");

                if (htmlElement) {
                    if (this.accessibilityMode) {
                        htmlElement.classList.add("accessibility-mode");
                    } else {
                        htmlElement.classList.remove("accessibility-mode");
                    }
                }
            },
        },
        created() {
            // Luk dropdown, hvis brugeren klikker udenfor
            window.addEventListener("click", (e) => {
                if (!this.$el.contains(e.target)) {
                    this.closeDropdown();
                }
            });

            // Tastatur-håndtering
            window.addEventListener("keydown", (e) => {
                if (!this.selectedDropdownId) return;

                const dropdown = document.getElementById(this.selectedDropdownId);
                if (!dropdown) return;

                const focusable = Array.from(dropdown.querySelectorAll('[tabindex="0"], a, button'));
                const focusedIndex = focusable.indexOf(document.activeElement);

                if (e.key === "Tab") {
                    if (e.shiftKey && focusedIndex === 0) {
                        e.preventDefault();
                        focusable[focusable.length - 1].focus();
                    } else if (!e.shiftKey && focusedIndex === focusable.length - 1) {
                        e.preventDefault();
                        focusable[0].focus();
                    }
                } else if (e.key === "Escape") {
                    this.closeDropdown();
                }
            });

            // Indstil tilgængelighedstilstand fra cookie
            const cookieValue = document.cookie.split('; ').find(row => row.startsWith('accessibilityMode='));
            if (cookieValue) {
                this.accessibilityMode = cookieValue.split('=')[1] === 'true';
            }
        },
    });
});
